import { FlexTypography, IFlexTypographyProps } from "@lyfegen-platform/react-common";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import useResizeObserver from "../hooks/use-resize-observer";

type IProps = Omit<IFlexTypographyProps, "width">;

const FlexTypographyComponent: React.FC<IProps & { containerStyles?: CSSProperties }> = (props) => {
	const { ref, width = 1 } = useResizeObserver<HTMLDivElement>();
	const fProps = {
		...props,
		width,
		flexAlignment: props.containerStyles?.justifyContent || "",
	};

	return (
		<div ref={ref} style={{ ...props.containerStyles } as React.CSSProperties}>
			<FlexTypography {...fProps} />
		</div>
	);
};

export default FlexTypographyComponent;
